module.exports = __webpack_public_path__ + "static/media/E.546b0420.png";